import styled from "styled-components";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";

type TabProps = {
  active: boolean;
  isDisabled?: boolean;
};

export const TabsStyled = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`;

export const TabStyled = styled.div<TabProps>`
  width: 50%;
  flex-basis: 50%;
  text-align: center;
  border-bottom: ${(props) =>
    props.active
      ? `1px solid ${Color.ModernGreen}`
      : `1px solid ${Color.SeaBlue200}`};

      p {
      margin-bottom: 10px;
      }

  &:hover {
    background-color: ${(props) =>
      props.isDisabled ? "none" : Color.SeaBlue200};
    cursor: ${(props) => (props.isDisabled ? "auto" : "pointer")};
  }
`;
